import React from 'react';
import { withTheme } from 'styled-components';
import Ratings from 'react-ratings-declarative';
import { number, string, object } from 'prop-types';

const STAR_RATING_FULL_COLOR = theme => theme.colors.starRatedColor;
const STAR_RATING_EMPTY_COLOR = theme => theme.colors.starEmptyColor;
const STAR_RATING_SPACING = '2px';
const STAR_RATING_DIMENSIONS = '16px';

const StarRating = ({
  rating,
  ratedColor,
  emptyColor,
  spacing = STAR_RATING_SPACING,
  dimension = STAR_RATING_DIMENSIONS,
  theme,
}) => {
  return (
    <Ratings
      rating={rating}
      widgetSpacings={spacing}
      widgetDimensions={dimension}
    >
      {[0, 1, 2, 3, 4].map(index => (
        <Ratings.Widget
          key={index}
          widgetRatedColor={ratedColor || STAR_RATING_FULL_COLOR(theme)}
          widgetEmptyColor={emptyColor || STAR_RATING_EMPTY_COLOR(theme)}
        />
      ))}
    </Ratings>
  );
};

StarRating.propTypes = {
  rating: number,
  maxRating: number,
  ratedColor: string,
  emptyColor: string,
  spacing: string,
  dimension: string,
  theme: object,
};

export default withTheme(StarRating);
